<template>
  <div>
    <div class="modal" :class="{ 'is-active': !!popUpSilo }">
      <div class="modal-background" @click="ModalClose"></div>
      <div class="modal-content">

        <div class="box modal-container">
          <div class="bottom-boder">
            <div class="p-5">
              <div class="select-a-setup-type">
                {{ isWhiteGloveUser ? 'Create new content plan' : 'Create new silo' }}
              </div>
              <button class="custom-modal-close-btn" aria-label="close" @click="ModalClose">
                <i class="material-icons">close</i>
              </button>
            </div>
          </div>
          <div class="modal-content-root px-5 pb-5">
            <v-text-field outlined dense hide-details class="mt-2 bg-white"
              :label="isWhiteGloveUser ? 'Enter content plan name' : 'Enter silo name'"
              v-model="searchTerm">
            </v-text-field>

            <div class="continue-button-area">
              <v-btn rounded class="button-with-icon back-button-text mr-2 mainColor--text text-none"
                @click="ModalClose">
                <span>Cancel</span>
              </v-btn>
              <v-btn :disabled="searchTerm?.length < 3" @click="onSubmit" rounded color="profileAnchorColor" class="continue-button-text whiteColor--text text-none">
                <span>Create</span>
              </v-btn>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { whiteGlovePlans } from '@/components/plans_constants'
import { getPureServicePkgName } from '@/utils'

export default {
  props: {
    popUpSilo: {
      default: null,
    },
    /** When absent, falls back to $route.params.campaignId (campaign keyword research routes). */
    campaignId: {
      type: [Number, String],
      default: undefined,
    },
  },
  data() {
    return {
      searchTerm: '',
      isFormSubmit: false,
    };
  },
  methods: {
    onSubmit() {
      this.isFormSubmit = true
      if (!this.searchTerm) return

      const cid = this.effectiveCampaignId
      if (!cid) {
        this.$notify({
          group: 'info',
          type: 'error',
          text: 'Missing campaign. Open keyword research from a campaign or refresh the page.',
        })
        return
      }

      this.$store.commit('showLoading')

      this.$store.dispatch('createSilo', { campaignId: cid, name: this.searchTerm }).then((silo) => {
        this.$emit("closeModal");
        this.$store.commit('setIsNewSiloUpdates', true);
        this.$emit("addKeywordToSilo", this.popUpSilo, { ...silo.data.data, silo_keywords: [] }, true);
        this.$notify({
          group: 'info', type: 'success',
          text: this.isWhiteGloveUser
            ? 'Successfully created content plan.'
            : 'Successfully created silo.',
        });
      }).finally(() => this.$store.commit('hideLoading'))
    },
    ModalClose() {
      this.$emit("closeModal");
    },
  },
  computed: {
    isWhiteGloveUser () {
      const user = this.$store.state.user
      if (!user) return false
      const accountType = this.$store.state.selectedSubAccountRelation
        ? this.$store.state.selectedSubAccountRelation.ownerAccountType
        : user.accountType
      return whiteGlovePlans.includes(getPureServicePkgName(accountType))
    },
    isError() {
      return this.isFormSubmit && !this.searchTerm;
    },
    effectiveCampaignId() {
      const p = this.campaignId
      if (p !== undefined && p !== null && p !== '') {
        const n = typeof p === 'number' ? p : parseInt(String(p), 10)
        if (!Number.isNaN(n) && n > 0) return n
      }
      const fromRoute = parseInt(this.$route.params.campaignId || 0, 10)
      return fromRoute > 0 ? fromRoute : null
    },
  },
  watch: {
    popUpSilo: function () {
      this.searchTerm = ''
    }
  },
};
</script>

<style lang="scss" scoped>
.bottom-boder {
  display: flex;
  border-bottom: 1px solid var(--v-grayColor-base);
}

.modal-content {
  width: 27.223vw;
  max-width: 27.223vw;
}

.modal-container {
  padding: 0 !important;
}

.material-icons {
  margin-top: -10px;
  color: var(--v-mainColor-base);
}

.back-button-text {
  border: 1px solid var(--v-mainColor-base);
  height: 38px !important;
  background: none !important;

  span {
    font-size: 17px !important;
    font-weight: 700 !important;
  }
}

.continue-button-text {
  height: 38px !important;

  i,
  span {
    font-size: 17px !important;
    font-weight: 700 !important;
  }

  i {
    margin-top: 2px;
  }
}

.select-a-setup-type {
  font-size: 1.25rem;
  font-weight: 700;
  text-align: left;
  color: var(--v-mainColor-base);
}

.continue-button-area {
  margin-top: 25px;
  text-align: right;
}
.bg-white {
  background-color: var(--v-whiteColor-base);
}

</style>
